import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import ClientFileFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/clientFile/ClientFileFormHandle';
import CardDetailsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/cardDetails/CardDetailsFormHandle';
import ClientListFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/clientList/ClientListFormHandle';
import CardListFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/cardList/CardListFormHandle';
import AccountListFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/accountList/AccountListFormHandle';
import CardProductsDetailsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/cardProductsDetails/CardProductsDetailsFormHandle';
import CardsNumberByStatusReasonAndCardNetworkTypeFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/cardsNumberByStatusReasonAndCardNetworkType/CardsNumberByStatusReasonAndCardNetworkTypeFormHandle';
import ListOfCardsToBeRenewedFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/listOfCardsToBeRenewed/ListOfCardsToBeRenewedFormHandle';
import ListOfNewCardsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/listOfNewCards/ListOfNewCardsFormHandle';
import OpposedCardsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/opposedCards/OpposedCardsFormHandle';

const Cardholders = () => {
  return (
    <div>
      <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Titulaire de carte
      </CC.Text>

      <CC.Tabs orientation='vertical'>
          <CC.TabList borderRight={'1px solid lightgray'} alignItems={'start'} textAlign={'start'}>
            <CC.Tab
              minWidth={'fit-content'}>
                Fichier client
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                Details des cartes
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                Liste des clients
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                liste des cartes
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                Liste des comptes
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                Details des produits cartes
            </CC.Tab>
            <CC.Tab
              textAlign={'left'}
              minWidth={'fit-content'}>
                Nbr. cartes par motif Stat et Type rés. carte
            </CC.Tab>
            <CC.Tab
              textAlign={'left'}
              minWidth={'fit-content'}>
                Liste des cartes pour renouvellement dans période
            </CC.Tab>
            <CC.Tab
              textAlign={'left'}
              minWidth={'fit-content'}>
                Liste nouvelles cartes par banque, agence, periode
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                Cartes opposées
            </CC.Tab>
          </CC.TabList>

        <CC.TabPanels>

          <CC.TabPanel>
            <ClientFileFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <CardDetailsFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <ClientListFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <CardListFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <AccountListFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <CardProductsDetailsFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <CardsNumberByStatusReasonAndCardNetworkTypeFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <ListOfCardsToBeRenewedFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <ListOfNewCardsFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <OpposedCardsFormHandle />
          </CC.TabPanel>


        </CC.TabPanels>
      </CC.Tabs>

    </div>
  )
}

export default Cardholders;